import { styled } from '@mui/material/styles';

export const ViewModeContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'Roboto, sans-serif',
});

export const ViewModeLabel = styled('div')({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '24px',
  color: '#666',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
});

export const ViewModeValue = styled('div')({
  fontSize: 16,
  fontWeight: 600,
  lineHeight: '24px',
  color: '#252a36',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
});
